import React from "react";
import { connect } from "react-redux";
import DartSound from "../DartSound/DartSound";
import Scoreboard from '../pages/Scoreboard/Scoreboard';
import Options from '../pages/Options/Options';
import Result from "../pages/Result/Result";

class ContextContainer extends React.Component {
  GlobalSoundPlayer = null;
  SoundPlayer = null;
  logo = null;

  componentDidUpdate(previousProps) {
    // Gestion des themes
    if (this.props.theme !== previousProps.theme) {
      this.setGlobalSoundPlayer("intro", this.props.theme);
    }
  }

  componentDidMount() {
    // hack pr contourner les législations autour des sound autoplayed sans interaction utilisateur
    this.logo.click();
    setTimeout(() => this.setGlobalSoundPlayer("intro", this.props.theme), 500)

  }

  renderTitle() {
    return <h1>{ }</h1>;
  }

  render() {
    const { isAuth, isEndGame } = this.props;
    const classContainer = isAuth ? "scoreboard--container" : "options--container";

    const childProps = {
      ...this.props,
      setSoundPlayer: this.setSoundPlayer
    }

    return (
      <div className={`container-container py-24 text-center ${classContainer}`} id="container">
        <div id="logo" ref={(e) => this.logo = e} />
        <div className="row">{this.renderTitle()}</div>
        {!isAuth ? <Options {...childProps} /> : !isEndGame ? <Scoreboard {...childProps} /> : <Result {...childProps} />}
        <div id="footer">
          <div className="animation">
            <div id="mario-perso" />
          </div>
        </div>
        <DartSound shuffle={true} volume={40} ref={(e) => (this.GlobalSoundPlayer = e)} key="globalSound" />
      </div>
    );
  }



  setGlobalSoundPlayer(track, theme) {
    if (this.GlobalSoundPlayer) {
      this.GlobalSoundPlayer.setTrack(track, theme);
    }
  }

}

const mapStateToProps = (state) => {
  return {
    ...state.scoreboard
  };
};

export default connect(mapStateToProps)(ContextContainer);
